var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAuction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0055 17.069V20.0278H22V22H10.0332V20.0278H12.0277V17.069H20.0055ZM2.75139 17.1632C2.26373 16.6811 2.75139 17.1632 2.00005 16.3638L8.85822 9.58203L7.62507 8.36239L6.9172 9.06249C6.817 8.9634 4.66633 6.83659 4.80307 6.9718L11.8536 0C11.9538 0.0990862 14.1043 2.22579 13.9676 2.09057L13.2659 2.78441L17.4994 6.97036L18.2058 6.2717C18.7965 6.85578 20.4248 8.46592 20.3201 8.36239L13.2696 15.3342C13.1694 15.2351 11.0187 13.1084 11.1554 13.2436L11.8581 12.5488L10.6238 11.3282L3.7659 18.1097C3.318 17.7235 3.23905 17.6455 2.75139 17.1632Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuction);
export default __webpack_public_path__ + "static/media/icon-auction.e7774a534abc9837dc82b8286f91f544.svg";
export { ForwardRef as ReactComponent };